import { createReducer } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import {
  MentorshipProgramActionItemTemplateSchema,
  MentorshipProgramActionItemTemplatesSchema,
} from 'redux/schemas/api/mentoring-program-action-item-templates';
import {
  getMentorshipProgramActionItemTemplates,
  createMentorshipProgramActionItemTemplate,
  updateMentorshipProgramActionItemTemplate,
  deleteMentorshipProgramActionItemTemplate,
} from 'redux/actions/mentoring-program-action-item-templates';
import { initialRootState } from '.';

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(getMentorshipProgramActionItemTemplates.fulfilled, (state, action) => {
      const { mentoringProgramId } = action.meta.arg;
      const { entities } = normalize(action.payload, MentorshipProgramActionItemTemplatesSchema);
      state.models.mentorshipProgramActionItemTemplates[mentoringProgramId] = entities.mentorshipProgramActionItemTemplates ?? {};
    })
    .addCase(createMentorshipProgramActionItemTemplate.fulfilled, (state, action) => {
      const { mentoringProgramId } = action.meta.arg;
      const { entities } = normalize(action.payload, MentorshipProgramActionItemTemplateSchema);
      state.models.mentorshipProgramActionItemTemplates[mentoringProgramId] = {
        ...state.models.mentorshipProgramActionItemTemplates[mentoringProgramId],
        ...entities.mentorshipProgramActionItemTemplates,
      };
    })
    .addCase(updateMentorshipProgramActionItemTemplate.fulfilled, (state, action) => {
      const { mentoringProgramId } = action.meta.arg;
      const { entities } = normalize(action.payload, MentorshipProgramActionItemTemplateSchema);
      state.models.mentorshipProgramActionItemTemplates[mentoringProgramId] = {
        ...state.models.mentorshipProgramActionItemTemplates[mentoringProgramId],
        ...entities.mentorshipProgramActionItemTemplates,
      };
    })
    .addCase(deleteMentorshipProgramActionItemTemplate.fulfilled, (state, action) => {
      const { mentoringProgramId, templateId } = action.meta.arg;
      delete state.models.mentorshipProgramActionItemTemplates[mentoringProgramId]?.[templateId];
    });
});
